var exports = {
  "ST": "FavoritesChannelListContent.module__channelBadgeSelected___cmNhQ2",
  "pJ": "FavoritesChannelListContent.module__channelBadgeSelectedIcon___cmNhQ2",
  "Vm": "FavoritesChannelListContent.module__favoriteItemContainer___cmNhQ2",
  "eb": "FavoritesChannelListContent.module__favoriteItem___cmNhQ2",
  "bu": "FavoritesChannelListContent.module__favoriteItemDefault___cmNhQ2",
  "Vb": "FavoritesChannelListContent.module__favoriteItemSelected___cmNhQ2",
  "q6": "FavoritesChannelListContent.module__favoriteItemOver___cmNhQ2",
  "xQ": "FavoritesChannelListContent.module__favoriteItemMuted___cmNhQ2",
  "H": "FavoritesChannelListContent.module__avatarContainer___cmNhQ2",
  "my": "FavoritesChannelListContent.module__avatar___cmNhQ2",
  "rZ": "FavoritesChannelListContent.module__avatarPlaceholder___cmNhQ2",
  "XQ": "FavoritesChannelListContent.module__channelBadge___cmNhQ2",
  "gg": "FavoritesChannelListContent.module__channelBadgeIcon___cmNhQ2",
  "QC": "FavoritesChannelListContent.module__displayName___cmNhQ2",
  "Hq": "FavoritesChannelListContent.module__actionsContainer___cmNhQ2",
  "af": "FavoritesChannelListContent.module__categoryItem___cmNhQ2",
  "Yq": "FavoritesChannelListContent.module__categoryContent___cmNhQ2",
  "yb": "FavoritesChannelListContent.module__categoryName___cmNhQ2",
  "Yl": "FavoritesChannelListContent.module__categoryIcon___cmNhQ2",
  "wp": "FavoritesChannelListContent.module__categoryActions___cmNhQ2",
  "Ef": "FavoritesChannelListContent.module__hoverAffordance___cmNhQ2",
  "It": "FavoritesChannelListContent.module__categoryAddButton___cmNhQ2",
  "n3": "FavoritesChannelListContent.module__categoryAddButtonIcon___cmNhQ2",
  "NP": "FavoritesChannelListContent.module__navigationContainer___cmNhQ2",
  "r0": "FavoritesChannelListContent.module__channelGroupsContainer___cmNhQ2",
  "kj": "FavoritesChannelListContent.module__uncategorizedGroup___cmNhQ2",
  "Mn": "FavoritesChannelListContent.module__keyboardFocus___cmNhQ2",
};

module.exports = exports;
